export enum Category {
	CytogeneticsAndMolecularGenetics = "CytogeneticsAndMolecularGenetics",
	FreeRadicals = "FreeRadicals",
}
